module.exports = __webpack_public_path__ + "static/media/oberflex-palissandre-2560x1440.70577247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-palissandre-2560x1440.jpg
// module id = 1049
// module chunks = 37